export enum AlertTypeEnum {
  Card = 1,
  Banner = 2
}
